import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';

const IPenEntityPickerFieldExtension = FormFieldBlueprint.make({
  name: 'IPenEntityPicker',
  params: {
    field: () =>
      import('./fields/IPenEntityPicker').then(m =>
        createFormField({
          name: 'IPenEntityPicker',
          component: m.IPenEntityPicker,
          schema: m.IPenEntityPickerFieldSchema,
        }),
      ),
  },
});

/**
 * Offers the LeanIX environments or business offerings of the application
 * behind a chosen Solution, reading the entities this repository's LeanIX
 * catalog provider ingests.
 *
 * Registered under the same name and `ui:options` contract as iPEN Portal's
 * field, so a template written for the portal renders unchanged here — only
 * the data source differs.
 */
const LeanixRelationPickerFieldExtension = FormFieldBlueprint.make({
  name: 'LeanixRelationPicker',
  params: {
    field: () =>
      import('./fields/LeanixRelationPicker').then(m =>
        createFormField({
          name: 'LeanixRelationPicker',
          component: m.LeanixRelationPicker,
          schema: m.LeanixRelationPickerFieldSchema,
        }),
      ),
  },
});

/**
 * Scaffolder field extensions copied from iPEN Portal, so portal software
 * templates render identically in the workbench.
 */
export const scaffolderModuleIpen = createFrontendPlugin({
  pluginId: 'scaffolder-module-ipen',
  extensions: [IPenEntityPickerFieldExtension, LeanixRelationPickerFieldExtension],
});
